import { ApiClientBase } from "api/ApiClientBase";

class EventsApiClient extends ApiClientBase {
    getRegionEvents(regionId, payload) {
        return this.post(`api/v1/federation-events/region/${regionId}`, payload).then(
            (r) => r.data,
        );
    }

    getFederationEvents(federationId, payload) {
        return this.post(`api/v1/federation-events/federation/${federationId}`, payload).then(
            (r) => r.data,
        );
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new EventsApiClient();
